export default {
  overview: {
    title: "Bill [[HWR.pl]]",
    subtitle: "Select a project and date range to view and bill [[hwr.pl]]",
    card: {
      info: {
        title: "Project",
        timeline: "Timeline",
        start_date: "Montage start",
        end_date: "Planned montage end",
        address: "Address",
        no_address: "No Adress data found",
        leading_users: "leading employees",
        no_leading_users: "no leading employees found",
      },
      filter: {
        title: "Filter",
        start_date_range: "Range",
        active_range: "Ausgewählter Zeitraum",
        submit: "Search",
        start_date_help: {
          title: "Explanation of calendar colors",
          red: "Red: One or more reports are available on this day. None is billed.",
          yellow: "Yellow: One or more reports are available on this day. Not all are billed (e.g. 2/3 billed).",
          green: "Green: One or more reports are available on this day. All are billed.",
          white: "White: No reports are available on this day.",
        },
      },
      result: {
        title: "[[HWR.pl]]",
        selected: "Selected",
        bill: "Bill",
        loading: "Loading [[hwr.pl]]...",
        reports_found: "report found",
        reports_found_plural: "reports found",
        steps: {
          step1_title: "Select a project",
          step1_description: "Choose a project from the project selector",
          step2_title: "Choose date range",
          step2_description: "Pick a date range to filter [[hwr.pl]]",
          step3_title: "Search reports",
          step3_description: "Click the search button to view results",
        },
        mark: {
          // Also the accessible name of the icon-only menu activator in the select column's header.
          title: "Marked",
          all: "All",
          unbilled: "Non-billed",
          none: "None",
        },
        manual_bill: "Manual Bill",
        again_bill: "Bill Again",
        bill_exists: "Billed",
        draft_exists: "Draft created",
        bill_not_exists: "Not yet billed",
        no_categories: "Not Set",
        table: {
          number: "Number",
          description: "Description",
          start_date: "Execution Date",
          categories: "Categories",
          billed: "Billed",
        },
      },
      bill: {
        title: "Create Invoice",
        subtitle: "Create invoice for selected reports",
        // Last resort for a print that failed without a violation the app can name (a server error,
        // a dropped connection). The dialog is the only place the failure is reported, so it must
        // never be left blank.
        failed: "The invoice could not be created. Please try again.",
        warning: {
          notPrintedTitle: "Reports Not Yet Printed with number",
          alreadyBilledTitle: "Reports Already Billed with number",
          notPrinted: "Report No. <strong>{value}</strong> is not yet printed",
          alreadyBilled: "Report No. <strong>{value}</strong> is already billed",
        },
        problem: {
          title: "Invoice cannot be created",
          subtitle: "A price is missing for the entries below. While any of them is open, no invoice can be created.",
          checking: "Checking prices ...",
          fix: "Fix",
          open: "Open",
          failed: "The price could not be saved.",
          hourly_rate: "Hourly rate",
          purchase_price: "Purchase price",
          real_price: "Real price",
          selling_price: "Selling price",
          scope_project: "Applies to this project only.",
          scope_selling: "A fixed price in this project. 0 means free of charge.",
          scope_masterdata: "Stored in the master data and therefore applies to all projects.",
        },
        options: {
          title: "Invoice Options",
          draft: "Draft",
          draft_description: "Save as draft without finalizing",
          hideProjectNumber: "Hide Invoice Number",
          hideProjectNumber_description: "Hide project number from invoice",
          customNumber: "Assign own invoice number",
          customNumber_description:
            "Replaces the running number on the invoice and in the file name. The project keeps counting as usual.",
          customNumber_field: "Invoice number",
          hideCreatedAtDate: "Hide Print Date",
          hideCreatedAtDate_description: "Hide creation date from invoice",
        },
        create: "Create Invoice",
      },
    },
  },
}
